<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="d-inline-block mb-0 me-4">{{ $t("content.amnuserright") }}</h5> 
                  <div>
                    <material-button color="primary" class="float-lg-start float-sm-end mb-0" disabled @click="openAddModal">
                      <i class="material-icons material-symbols-outlined">add</i>
                       {{ $t("content.addnewurole") }}
                    </material-button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row"> 
                  <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_group" @change="shoplist">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shop" :disabled="search_group === ''" @change="loadRoleList">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.roleempsh") }}</label>
                    <select v-model="role_search" class="form-select" :disabled="search_group === ''|| search_shop === ''">
                      <option value="">{{ $t('content.optall') }}</option>
                      <option v-for="(item, index) in roleList" :value="item.businessRole" :key="index">
                        {{ item.businessRole }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      @click="loadDataApi" :disabled="search_group === '' || search_shop === ''">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th class="text-center">{{ $t("content.roleempsh") }}</th>
                          <th class="text-center">{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- วนลูปแสดงแถวพนักงานแยกตามรายการข้อมูลจากตัวแปร roles ตรง ๆ -->
                        <tr v-for="(row, index) in listdata" :key="row.uid || index">
                          
                          <!-- คอลัมน์ที่ 1: ลำดับตัวเลขพนักงานแถวหลัก -->
                          <td class="text-sm font-weight-normal align-middle">
                              {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                          </td>

                          <!-- คอลัมน์ที่ 2: บทบาทหน้าที่ (จัดให้อยู่ตรงกลางคอลัมน์ด้วย text-center) -->
                          <td class="text-sm font-weight-normal py-3 text-center align-middle">
                            <span 
                              style="font-size: 13px; letter-spacing: 0.3px; padding: 6px 0; border-radius: 6px; font-weight: 600; display: inline-block; width: 140px; text-align: center;"
                              :style="getRoleBadgeStyle(row.businessRole)">
                              {{ row.businessRole }}
                            </span>
                          </td>
                          
                          <!-- คอลัมน์ที่ 3: กลุ่มปุ่มจัดการ Actions (จัดให้ชิดขวาสุดด้วย text-center) -->
                          <td class="text-sm font-weight-normal align-middle text-center">
                            <material-button color="info" variant="outline" class="rounded-circle" :title="$t('content.editurole')" disabled @click="openEditModal(row)">
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle" :title="$t('content.deleteurole')" disabled @click="openDeleteModal(row)">
                              <i class="material-icons material-symbols-outlined">delete</i>
                            </material-button>
                          </td>
                        </tr>
                        
                        <!-- แถวแสดงเมื่อขนาดข้อมูลในตัวแปร roles มีค่าเป็น 0 -->
                        <tr v-if="listdata.length === 0">
                          <td colspan="7" class="text-sm font-weight-normal py-4">
                            <p style="text-align: center" class="text-muted mb-0">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="9" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>

              </div>
            </div>

            
            <!-- Add/Edit Shop Role Modal -->
            <div id="shopRoleModal" class="modal fade" tabindex="-1" aria-labelledby="shopRoleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" style="max-width: 750px;">
                <div class="modal-content border-0 shadow-lg overflow-hidden" style="border-radius: 12px;">
                  
                  <!-- MODAL HEADER -->
                  <div class="p-4 text-white" :style="{ backgroundColor: isEditMode ? '#0284c7' : '#00b074' }">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h4 class="modal-title fw-bold m-0" style="font-size: 20px; letter-spacing: 0.3px; color: #ffffff !important;">
                          {{ isEditMode ? 'Edit Shop Role' : 'Add New Shop Role' }}
                        </h4>
                        <p class="text-white opacity-85 small mb-0 mt-1" style="font-size: 13.5px;">
                          {{ isEditMode ? 'แก้ไขสิทธิ์ผู้ใช้งาน' : 'เพิ่มสิทธิ์ผู้ใช้งาน' }}
                        </p>
                      </div>
                      <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close" @click="resetForm"></button>
                    </div>
                  </div>

                  <!-- MODAL BODY -->
                  <div class="modal-body px-4 py-3 bg-white" style="max-height: 75vh; overflow-y: auto;">
                    <div class="row g-3">

                      <!-- ส่วนเลือก Group -->
                      <div class="col-md-12">
                        <label class="form-label small text-secondary mb-1" style="font-size: 13px; color: #4a5568 !important;">Group</label>
                        <select v-model="roleForm.groupUid" class="form-select form-select-sm rounded shadow-none" style="padding: 0.4rem 0.75rem; font-size: 13.5px; border-color: #cbd5e1 !important;"
                         required :disabled="isEditMode" @change="getShopList">
                          <option value="" disabled selected>— Select group —</option>
                          <option v-for="g in listgroup" :key="g.uid" :value="g.uid">{{ g.name }}</option>
                        </select>
                      </div>

                      <!-- ส่วนเลือก Shop -->
                      <div class="col-md-6">
                        <label class="form-label small text-secondary mb-1" style="font-size: 13px; color: #4a5568 !important;">Shop</label>
                        <select v-model="roleForm.shopUid" class="form-select form-select-sm rounded shadow-none" style="padding: 0.4rem 0.75rem; font-size: 13.5px; border-color: #cbd5e1 !important;" required :disabled="isEditMode || !roleForm.groupUid">
                          <option value="" disabled selected>— Select shop —</option>
                          <option v-for="s in shopList" :key="s.uid" :value="s.uid">{{ s.code }} - {{ s.nameTh }}</option>
                        </select>
                      </div>
                      
                      <!-- ส่วนกรอก Business Role -->
                      <div class="col-md-6">
                        <label class="form-label small text-secondary mb-1" style="font-size: 13px; color: #4a5568 !important;">Business Role</label>
                        <input v-model="roleForm.businessRole" type="text" class="form-control rounded shadow-none" style="padding: 0.375rem 0.75rem; font-size: 13.5px; height: 38px; border-color: #cbd5e1 !important;" placeholder="ตัวอย่างเช่น SHOP_MANAGER" required />
                      </div>

                      <!-- ส่วนจัดการสิทธิ์การใช้งาน (functionUids) - ไม่บังคับเลือก -->
                      <div class="col-md-12 mt-4">
                        <label class="form-label small fw-bold text-dark mb-2" style="font-size: 14px;">
                          ฟังก์ชันและสิทธิ์การเข้าใช้งาน (Functions Permission) <span class="text-muted fw-normal">(ไม่บังคับเลือก)</span>
                        </label>
                        <div class="border rounded p-3 bg-light" style="max-height: 200px; overflow-y: auto; border-color: #e2e8f0 !important;">
                          <div class="row g-2">
                            <div class="col-md-6" v-for="func in functionList" :key="func.uid">
                              <div class="form-check d-flex align-items-center gap-2">
                                <!-- ติ๊กเลือกหรือไม่ติ๊กเลือกก็ได้ ปุ่ม SAVE/UPDATE จะไม่โดนบล็อกแล้ว -->
                                <input class="form-check-input shadow-none cursor-pointer" type="checkbox" :id="'func-' + func.uid" :value="func.uid" v-model="roleForm.functionUids">
                                <label class="form-check-label small text-dark cursor-pointer mb-0 text-truncate" :for="'func-' + func.uid">
                                  {{ func.name }} <span class="text-muted text-xs">({{ func.code }})</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-12 text-center text-muted small py-3" v-if="!functionList || functionList.length === 0">
                              ไม่พบข้อมูลสิทธิ์ระบบเพื่อกำหนดให้เลือก
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- MODAL FOOTER CONTROLS -->
                  <div class="modal-footer border-top-0 px-4 pb-4 pt-2 d-flex justify-content-end align-items-center gap-3 bg-white">
                    <button type="button" class="btn btn-link text-secondary text-decoration-none shadow-none fw-bold p-0" data-bs-dismiss="modal" @click="resetForm" style="font-size: 13.5px; letter-spacing: 0.3px;">
                      CANCEL
                    </button>
                    <button
                      type="button"
                      class="btn text-white px-4 py-1.5 shadow-none fw-bold rounded-2"
                      :style="{ backgroundColor: isEditMode ? '#0284c7' : '#00b074', minWidth: '100px', border: 'none', fontSize: '13.5px', letterSpacing: '0.3px' }"
                      :disabled="isFormInvalid"
                      @click="submitRoleForm">
                      {{ isEditMode ? 'UPDATE' : 'SAVE' }}
                    </button>
                  </div>

                </div>
              </div>
            </div>


            <!-- Delete Shop Role Modal -->
            <div id="deleteShopRoleModal" class="modal fade" tabindex="-1" aria-labelledby="deleteShopRoleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" style="max-width: 460px;">
                <div class="modal-content border-0 shadow-lg p-4 text-center" style="border-radius: 16px;">
                  
                  <!-- MODAL BODY: จัดตำแหน่งให้อยู่ตรงกลางทั้งหมด -->
                  <div class="modal-body p-0">
                    
                    <!-- ไอคอนรูปกุญแจ/สิทธิ์สีแดงในวงกลมสีชมพูอ่อน ดัดแปลงให้เข้ากับการลบบทบาทหน้าที่ -->
                    <div class="d-flex align-items-center justify-content-center mx-auto mb-3" 
                        style="width: 70px; height: 70px; background-color: #ffe8e8; border-radius: 50%;">
                      <span class="material-icons text-danger" style="font-size: 32px;">vpn_key</span>
                    </div>

                    <!-- หัวข้อลบบทบาทหน้าที่ -->
                    <h4 class="fw-bold mb-2" style="color: #2d3748; font-size: 22px;">Delete Shop Role</h4>
                    
                    <!-- ข้อความแจ้งเตือนดึงค่าตามสิทธิ์บทบาทและชื่อร้านที่เลือก -->
                    <p class="text-secondary mb-4 px-2" style="font-size: 15px; color: #718096 !important;">
                      คุณแน่ใจหรือไม่ที่จะลบสิทธิ์ผู้ใช้งาน <span class="fw-bold" style="color: #e53e3e;">{{ deleteRoleForm.businessRole }}</span> 
                      ออกจากสาขา <span class="fw-bold" style="color: #4a5568;">{{ deleteRoleForm.shopName }}</span> อย่างถาวร ?
                    </p>

                    <!-- กลุ่มปุ่มกดยืนยันการลบ จัดแบบแนวนอนขนานกันคู่กันตามต้นแบบ -->
                    <div class="d-flex justify-content-center gap-3">
                      <button type="button" class="btn btn-light text-secondary fw-semibold border-0 px-4 py-2 rounded-3 shadow-none" 
                              data-bs-dismiss="modal" style="background-color: #f1f3f9; min-width: 110px; font-size: 14px;">
                        Cancel
                      </button>
                      
                      <button type="button" class="btn btn-danger fw-semibold px-4 py-2 rounded-3 shadow-none" 
                              style="background-color: #e53e3e; border: none; min-width: 110px; font-size: 14px;"
                              @click="handleDeleteShopRole">
                        Delete
                      </button>
                    </div>

                  </div>

                </div>
              </div>
            </div>


          </div>            
        </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, computed, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import Modal from 'bootstrap/js/dist/modal';
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

import { useSecShopRoleStore } from '@/stores/secshoprole'
import { useGroupStore } from "@/stores/group";
import { useShopStore } from "@/stores/shop";

const { t } = useI18n();
const swal = inject("$swal");

const storesec_sr = useSecShopRoleStore()
const storegr = useGroupStore()
const storesh = useShopStore()

const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const save = computed(() => t("buttons.save"));
const btnSearch = computed(() => t("buttons.sear"));


// ── Mock data ────────────────────────────────────────────────────────────────

const roles = ref([
  { id: 1,  shopUid: '564650065004595065', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 2,  shopUid: '564650065004595065', employeeNumber: 'NW0001',   nameTh: 'นาค1 นิวาส',        email: 'nwuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 3,  shopUid: '564650065004595065', employeeNumber: 'NW0002',   nameTh: 'นาค2 นิวาส',        email: 'nwuser02@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 4,  shopUid: '564650065004595065', employeeNumber: 'NW0009',   nameTh: 'วิทิต',              email: 'how@nvtx.tech',        role: 'SHOP_MANAGER' },
  { id: 5,  shopUid: '564650065004595065', employeeNumber: 'NW0003',   nameTh: 'นาค3 นิวาส',        email: 'nwuser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 6,  shopUid: '564650065004595065', employeeNumber: 'NW0004',   nameTh: 'นาค4 นิวาส',        email: 'nwuser04@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 7,  shopUid: '564650065004595065', employeeNumber: 'NW0005',   nameTh: 'นาค5 นิวาส',        email: 'nwuser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 8,  shopUid: '564650065004595065', employeeNumber: 'NW0006',   nameTh: 'นาค6 นิวาส',        email: 'nwuser06@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 9,  shopUid: '564650065004595065', employeeNumber: 'NW0007',   nameTh: 'นาค7 นิวาส',        email: 'nwuser07@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 10, shopUid: '564650065004595065', employeeNumber: 'NW0008',   nameTh: 'นาค8 นิวาส',        email: 'nwuser08@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 11, shopUid: '564650609597220734', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 12, shopUid: '564650609597220734', employeeNumber: 'KL0001',   nameTh: 'คลอง1 หลวง',        email: 'kluser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 13, shopUid: '564650609597220734', employeeNumber: 'NW0009',   nameTh: 'วิทิต',              email: 'how@nvtx.tech',        role: 'SHOP_MANAGER' },
  { id: 14, shopUid: '564650609597220734', employeeNumber: 'KL0003',   nameTh: 'คลอง3 หลวง',        email: 'kluser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 15, shopUid: '564650609597220734', employeeNumber: 'KL0005',   nameTh: 'คลอง5 หลวง',        email: 'kluser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 16, shopUid: '564650609597220734', employeeNumber: 'KL0007',   nameTh: 'คลอง7 หลวง',        email: 'kluser07@nvtx.tech',   role: 'VAULT_KEEPER' },
  { id: 17, shopUid: '590532343199164463', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน',  email: 'bdmnadmin01@nvtx.tech', role: 'GROUP_ADMIN' },
  { id: 18, shopUid: '590532343199164463', employeeNumber: 'TR0001',   nameTh: 'TR1',                email: 'truser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 19, shopUid: '590532343199164463', employeeNumber: 'TR0003',   nameTh: 'TR3',                email: 'truser03@nvtx.tech',   role: 'THAI_CLERK' },
  { id: 20, shopUid: '590532343199164463', employeeNumber: 'TR0005',   nameTh: 'TR5',                email: 'truser05@nvtx.tech',   role: 'CHINESE_CLERK' },
  { id: 21, shopUid: '590532688809814064', employeeNumber: 'BM0001',   nameTh: 'BM1',                email: 'bmuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
  { id: 22, shopUid: '628611923313744384', employeeNumber: 'NV0001',   nameTh: 'NV1',                email: 'nvuser01@nvtx.tech',   role: 'SHOP_MANAGER' },
])

const userList = [
  { uid: 'u1', employeeNumber: 'NW0001',   nameTh: 'นาค1 นิวาส' },
  { uid: 'u2', employeeNumber: 'NW0002',   nameTh: 'นาค2 นิวาส' },
  { uid: 'u3', employeeNumber: 'NW0009',   nameTh: 'วิทิต' },
  { uid: 'u4', employeeNumber: 'KL0001',   nameTh: 'คลอง1 หลวง' },
  { uid: 'u5', employeeNumber: 'TR0001',   nameTh: 'TR1' },
  { uid: 'u6', employeeNumber: 'BM0001',   nameTh: 'BM1' },
  { uid: 'u7', employeeNumber: 'NV0001',   nameTh: 'NV1' },
  { uid: 'u8', employeeNumber: 'BDMN0001', nameTh: 'บีดีเอ็ม แอดมิน' },
]

let nextId = 100

// ── Filters ──────────────────────────────────────────────────────────────────

const shopList = ref([]);
const roleList = ref([]);
const listdata = ref([]);
const role_search = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const listgroup = ref([]);
const listshop = ref([]);
const search_group = ref("");
const search_shop = ref("");


const isEditMode = ref(false);
const functionList = ref([]);

const roleForm = reactive({
  uid: '',
  groupUid: '',
  shopUid: '',
  businessRole: '',
  functionUids: [], 
  version: 0
});

const deleteRoleForm = reactive({
  uid: '',
  businessRole: '',
  shopName: '', // เอาไว้แสดงผลบนข้อความแจ้งเตือนใน Modal
  version: 0
});


const isFormInvalid = computed(() => {
  return (
    !roleForm.groupUid ||
    !roleForm.shopUid ||
    !roleForm.businessRole.trim() 
  );
});

// 1. ล้างข้อมูลฟอร์ม
const resetForm = () => {
  roleForm.uid = '';
  roleForm.groupUid = '';
  roleForm.shopUid = '';
  roleForm.businessRole = '';
  roleForm.functionUids = [];
  roleForm.version = 0;
};

// 2. เรียกใช้งานเมื่อกดปุ่ม "+ เพิ่มสิทธิ์ผู้ใช้งาน" บนหน้าหลัก
const openAddModal = () => {
  isEditMode.value = false;
  resetForm();
  openModalElement('shopRoleModal');
};

const openEditModal = (rowData) => {
  shopList.value = [];
  isEditMode.value = true;
  roleForm.uid = rowData.uid;
  roleForm.groupUid = rowData.groupUid;
  roleForm.shopUid = rowData.shopUid;
  roleForm.businessRole = rowData.businessRole;
  roleForm.functionUids = Array.isArray(rowData.functionUids) ? [...rowData.functionUids] : [];
  roleForm.version = rowData.version || 0;
  if (roleForm.groupUid !== '0') {
    getShopList();
  }
  openModalElement('shopRoleModal');
};


const openDeleteModal = async (rowData) => {
  shopList.value = [];
  roleForm.groupUid = rowData.groupUid;
  if (roleForm.groupUid !== '0') {
    // 2. ใส่ await บังคับให้ระบบรอจนกว่าจะดึงข้อมูลสาขาเข้า shopList เสร็จสมบูรณ์
    await getShopList();
  }
  
  // 3. ดึงชั้นข้อมูล data.list ตามที่เช็กได้จากโครงสร้าง Network Response ของคุณ
  const originalShops = shopList.value?.data?.list || shopList.value || [];
  
  // 4. ทำการค้นหาข้อมูลหลังจากมีค่าในลิสต์สาขาแล้วแน่นอน
  const targetShop = originalShops.find(
    shop => String(shop.uid).trim() === String(rowData.shopUid).trim()
  );
  
  // 5. แสดงผลเป็นรูปแบบ "รหัส - ชื่อภาษาไทย" หรือหากหาไม่เจอจริงๆ ให้ใช้รหัส Uid สำรอง
  deleteRoleForm.shopName = targetShop ? `[${targetShop.code}]` : (rowData.shopUid || '');
  
  deleteRoleForm.uid = rowData.uid;
  deleteRoleForm.businessRole = rowData.businessRole;
  deleteRoleForm.version = rowData.version || 0;
  
  openModalElement('deleteShopRoleModal');
};

const onClickHandler = (page) => {
  updatePagination()
};

const loadRoleList = async () => {
  roleList.value = [];
  let data = "";
  data = {
    shopUid: search_shop.value,
    businessRole:''
  };
  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        roleList.value = response.data.data.list
      }
    }
  }
}

const loadgroupListApi = async (val) => {
  listgroup.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
  };
  const payload = data;
  // console.log("loadgroupListApi p : " + JSON.stringify(payload));
  const response = await storegr.groupListFetch(payload);
  // console.log("loadgroupListApi r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listgroup.value = response.data.data.list;
      }
    }
  }
}

loadgroupListApi();

async function shoplist() {
  listshop.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_group.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop.value = response.data.data.list;
      }
    }
  }
}


const loadDataApi = async (val) => {
  let data = "";
  if (currentPage.value !== 1) {
    if (listdata.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: search_shop.value,
    businessRole: role_search.value,
  };

  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const filteredList = response.data.data.list
        listdata.value = filteredList;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}

async function updatePagination() { 
  let data = "";
  listdata.value = []

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    shopUid: search_shop.value,
    businessRole: role_search.value,
  };

  const payload = data;
  const response = await storesec_sr.shopRoleListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const filteredList = response.data.data.list
        listdata.value = filteredList;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}


async function getShopList() {
  shopList.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: roleForm.groupUid,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shopList.value = response.data.data.list;
      }
    }
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


// ฟังก์ชันแจกจ่ายสีพื้นหลังและสีอักษรให้สวยงาม มีมิติตามสากลแบบตรงเฉดสี UI ล่าสุด
const getRoleBadgeStyle = (roleName) => {
  switch (roleName) {
    case 'GROUP_ADMIN':
      return { backgroundColor: '#ffe8e8', color: '#e53e3e' } // สีแดง
    case 'SHOP_MANAGER':
      return { backgroundColor: '#e8ebff', color: '#3f51b5' } // สีน้ำเงิน/ม่วง
    case 'THAI_CLERK':
      return { backgroundColor: '#dcfce7', color: '#15803d' } // สีเขียว
    case 'CHINESE_CLERK':
      return { backgroundColor: '#fef9c3', color: '#a16207' } // สีเหลือง/ส้มทอง
    case 'VAULT_KEEPER':
      return { backgroundColor: '#f3e8ff', color: '#7c3aed' } // สีม่วง
    default:
      return { backgroundColor: '#f1f5f9', color: '#475569' } // สีเทา
  }
}

const submitRoleForm = async () => {
  if (isFormInvalid.value) return;
  try {
    let response;

    // 1. จัดการเตรียมสิทธิ์ว่างตามหลังบ้านต้องการ
    if (roleForm.functionUids.length === 0) {
      roleForm.functionUids = [""];
    }

    // 2. ปรับโครงสร้าง payload บังคับแปลงไทป์ให้เป็น String ทั้งหมดตามลิสต์ API
    const payload = {
      uid: String(roleForm.uid || ""),
      groupUid: String(roleForm.groupUid),
      shopUid: String(roleForm.shopUid),
      businessRole: String(roleForm.businessRole),
      functionUids: roleForm.functionUids,
      version: String(roleForm.version || "0")
    };

    // console.log('payload : ' + JSON.stringify(payload));

    // แยกตามประเภทการทำงาน (เปลี่ยนไปส่งก้อน payload ที่เตรียมไว้แทน)
    if (isEditMode.value) {
      response = await storesec_sr.shopRoleUpdateFetch(payload);
    } else {
      response = await storesec_sr.shopRoleAddFetch(payload);
    }
    
    // โครงสร้างดักตรวจสอบ Response เหมือนเดิม...
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          closeModalElement('shopRoleModal');
          swal("บันทึกสำเร็จ", "", "success");
          resetForm();
          if (search_shop.value !== '') {
            await loadDataApi();
          }
          await loadRoleList();
        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
        }
      }
    }
  } catch (error) {
    console.error('เกิดข้อผิดพลาดไม่สามารถบันทึกข้อมูลสิทธิ์ได้:', error);
    swal("เกิดข้อผิดพลาด", "ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่อีกครั้ง", "error");
  }
};

const handleDeleteShopRole = async () => {
  if (!deleteRoleForm.uid) return;

  const payload = {
    uid: deleteRoleForm.uid,
  };

  try {
    // เรียกใช้งาน API ลบข้อมูล
    const response = await storesec_sr.shopRoleDeleteFetch(payload);
    
    // ดักเช็กโครงสร้างการตอบกลับตามแบบฉบับ handleSetPin เป๊ะๆ
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          closeModalElement('deleteShopRoleModal');
          swal("ลบข้อมูลสำเร็จ", "", "success");
          if (search_shop.value !== '') {
            await loadDataApi();
          }
          await loadRoleList();
        } else {
          swal("ลบข้อมูลไม่สำเร็จ", response.data.rtnDesc, "error");
        }
      }
    }
  } catch (error) {
    console.error('เกิดข้อผิดพลาดไม่สามารถลบสิทธิ์บทบาทได้:', error);
    swal("เกิดข้อผิดพลาด", "ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่อีกครั้ง", "error");
  }
};

// ฟังก์ชันส่วนกลางสำหรับเรียกใช้ Bootstrap Modal
function openModalElement(modalId) {
  const modalElement = document.getElementById(modalId)
  if (modalElement) {
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement)
    modalInstance.show()
  }
}

function closeModalElement(modalId) {
  const modalElement = document.getElementById(modalId)
  if (modalElement) {
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement)
    modalInstance.hide()
  }
}

</script>


